function timeExchange (UTCDateString) {
  if (!UTCDateString) {
    return '-'
  }
  function formatFunc (str) {
    return str > 9 ? str : '0' + str
  }
  var date2 = new Date(UTCDateString)
  var year = date2.getFullYear()
  var mon = formatFunc(date2.getMonth() + 1)
  var day = formatFunc(date2.getDate())
  var hour = date2.getHours()
  var noon = hour >= 12 ? 'PM' : 'AM'
  hour = hour >= 12 ? hour - 12 : hour
  hour = formatFunc(hour)
  var min = formatFunc(date2.getMinutes())
  var second = formatFunc(date2.getSeconds())
  var dateStr =
    year +
    '-' +
    mon +
    '-' +
    day +
    ' ' +
    noon +
    ' ' +
    hour +
    ':' +
    min +
    ':' +
    second
  return dateStr
}

export default timeExchange



// WEBPACK FOOTER //
// ./src/utils/timeExchange.js